import React from 'react';
import { Link } from 'react-router-dom';

import { urlJoin } from '../../utils/url-utils';
import './card.css';
import img from '../../images/img-default.png';
import moment from 'moment/moment';

export default class Card extends React.Component {
    render() {
        const { card, url } = this.props;
        const { picture, title, description, id, expired } = card;
        const canAccess = !expired;

        return (
            <div className='card'>
                <div className='card-img'>
                    <img src={picture ? picture : img} alt={title ? title : 'imagem background'}/>
                </div>
                <div className='card-data'>
                    <div>
                        <span className='card-title'>{title ? title : 'Titulo'}</span>
                        <p className='card-descr' title={description}>{description ? description : 'descrição'}</p>
                    </div>
                    {canAccess &&
                        <Link to={urlJoin(url, id)}>
                            <button className='card-access'>Acessar</button>
                        </Link> }
                    {this.renderExpirationInfo()}
                </div>
            </div>
        );
    }

    renderExpirationInfo = () => {
        const { startDate, endDate } = this.props.card;
        const { eadEndDate } = this.props;
        const isEnded = moment().startOf('d') > moment(endDate).endOf('d');
        if (!isEnded) {
            return (
                <div className='expiration-info'>
                    {this.renderExpirationString(endDate, startDate, eadEndDate)}
                </div>
            );
        } else {
            return (
                <div className='expiration-info'>
                    <p>Esse item expirou</p>
                </div>
            );
        }
    };

    renderExpirationString = (endDate, startDate, eadEndDate) => {
        const isStarted = moment(startDate).startOf('d') <= moment().startOf('d');
        const expires = endDate && (isStarted || !startDate);
        const notExpires = !endDate && (isStarted || !startDate);
        if (!notExpires) {
            const expiresIn = eadEndDate || endDate;
            return expires ? <p>Expira em {moment(expiresIn).format('DD/MM/YYYY')}</p> :
                <p>Inicia em {moment(startDate).format('DD/MM/YYYY')}</p>;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/card/card.js